import axios, { AxiosError } from 'axios'
import { setupLoadingInterceptor } from './utils/loading';
import { setupMessageInterceptor } from './utils/message';
import { setupResponseInterceptor } from './utils/response';
import type { CustomAxiosRequestConfig } from './utils/interface';
import { useAuthCandidateStore } from '@/stores/auth_candidate';
import { useCompanyStore } from '@/stores/company';
import { portalJobsService } from '@/services/portal_jobs';

const httpPortalJob = axios.create({
    baseURL: import.meta.env.VITE_APP_URL,
    withCredentials: true
})

httpPortalJob.interceptors.request.use((config: CustomAxiosRequestConfig) => {

    const { token } = useAuthCandidateStore();

    if (token) {
        config.headers.Authorization = token;
    }

    const { nickname } = useCompanyStore();
    if (nickname) {
        config.headers['X-Company'] = nickname;
    }

    return config;
});


setupLoadingInterceptor(httpPortalJob);
setupMessageInterceptor(httpPortalJob);
setupResponseInterceptor(httpPortalJob)

// Resposta
httpPortalJob.interceptors.response.use(

    // Successo
    response => response,


    // Erro
    async (error: AxiosError) => {
        const config = error.config as CustomAxiosRequestConfig;

        if (error.status && error.response?.data) {
            const resError = (error.response.data as any)

            // Renova o token
            if (error.status == 401 && (resError.data == "invalid_token" || (resError instanceof Blob)) && !config._retry) {

                config._retry = true;
                try {
                    const newToken = await portalJobsService.refreshToken();

                    useAuthCandidateStore().token = newToken;
                    config.headers.Authorization = newToken;
                    return httpPortalJob(config);

                } catch (error) {
                    return Promise.reject(error);
                }
            }
        }


        return Promise.reject(error);
    });

export default httpPortalJob